import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { Permissao, Role } from '../../../utils/variables';
import { usePermit } from 'utils/hooks/usePermit';

import {
  FiPieChart,
  FiYoutube,
  FiInbox,
  FiFileText,
  FiKey,
  FiVoicemail,
  FiStar,
  FiArchive,
  FiTrendingUp,
  FiCoffee,
} from 'react-icons/fi';
import { BsCalendar2Check } from 'react-icons/bs';

import {
  Wrapper,
  Content,
  Container,
  SideBar,
  Menu,
  Item,
  Logo,
} from './styles';

import logo from 'assets/logo_white.svg';

import Header from 'components/Header';

import { Scroll } from 'styles/global';
export default function DefaultLayout({ children }) {
  const location = useLocation();
  const ref = useRef(null);
  const [collapseSolicitacoes, setCollapseSolicitacoes] = useState(false);
  const [collapsePromo, setCollapsePromo] = useState(false);
  const [collapseEleicoes, setCollapseEleicoes] = useState(false);
  const [collapseOpec, setCollapseOpec] = useState(false);
  const [collapseAdmin, setCollapseAdmin] = useState(false);
  const [collapseCedoc, setCollapseCedoc] = useState(false);
  const [collapseIndicadores, setCollapseIndicadores] = useState(false);
  const [collapseCriativos, setCollapseCriativos] = useState(false);

  const { isSideBarMini } = useSelector(state => state.usuario);
  const { profile } = useSelector(state => state.usuario);

  //Permissões: DASHBOARD
  const hasDashboard = usePermit([Role.OPEC, Role.ENG, Role.EXIB], []);
  //Permissões: PLAYER
  const hasPlayer = usePermit([Role.ENG, Role.EXIB], []);
  //Permissões: MELHORIA DO BREAK
  const hasMelhoriaDoBreak = usePermit([Role.MKT], []);
  //Permissões: OPEC
  const hasOpec = usePermit([Role.OPEC], []);
  const hasRoteiroExclusao = usePermit([Role.OPEC, Role.ENG, Role.EXIB], []);
  //Permissões: ELEIÇÕES
  const hasEleicoes = usePermit([Role.OPEC, Role.ENG], []);
  // Permissões: PRODUÇÃO
  const hasChamada = usePermit(
    [Role.PROMO, Role.PROG],
    [Permissao.CHVISUALIZADOR, Permissao.AVALIADOR],
  );
  const hasPromo = usePermit([Role.PROMO], []); // Anúncio + Spot + Roteiro Promo
  const hasProg = usePermit([Role.PROG], []); // Acesso ao calendário de produções

  const hasClosedCaption = usePermit(
    [Role.PROMO, Role.ENG, Role.EXIB, Role.CEDOC],
    [],
  );

  //Permissões: OPTATIVOS
  const hasOptativosLocais = usePermit(
    [Role.PROMO, Role.JORN, Role.ENG, Role.CEDOC, Role.EXIB],
    [],
  );
  // Permissões: SOLICITAÇÕES
  const hasSolicitacaoPromo = usePermit(
    [Role.PROMO, Role.PROG],
    [Permissao.SOLICITACAO],
  );
  const hasSolicitacaoChDigital = usePermit(
    [Role.PROMO, Role.PROG, Role.JORN],
    [Permissao.SOLICITACAO],
  );
  // Permissões: CEDOC
  const hasArquivamento = usePermit([Role.CEDOC], []);
  // Permissões: ADMIN
  const hasUsuario = usePermit([], [Permissao.USUARIOEDITOR]);
  const hasRelatorio = usePermit(
    [],
    [Permissao.RELATORIOCOM, Permissao.RELATORIOPROD, Permissao.RELATORIOOPTA],
  );

  const hasPrograma = usePermit(
    [Role.OPEC, Role.PROMO],
    [Permissao.PROGRAMAEDITOR, Permissao.ORA],
  );
  const hasORA = usePermit([], [Permissao.ORA]);

  const hasIndicadorComercial = usePermit([], [Permissao.INDICADORCOMERCIAL]);

  const hasCriativos = usePermit([Role.EXEC], [Permissao.CRIATIVOS]);

  function isActive(path) {
    return location.pathname === path;
  }

  // function closeSidebar() {
  //   if (!isSideBarMini) {
  //     if (window.innerWidth < 1170) {
  //       dispatch(toggleBar());
  //     }
  //   }
  // }

  // useOutsideClick(ref, () => {
  //   closeSidebar();
  // });
  return (
    <Wrapper>
      <Header />
      <Container>
        <SideBar ref={ref} $mini={isSideBarMini}>
          <div>
            <Logo $mini={isSideBarMini}>
              <img src={logo} alt="logo" />
            </Logo>
            <Menu>
              {profile && (
                <Scroll padding="0" height="calc(100vh - 190px)">
                  {hasDashboard && (
                    <Item
                      $active={isActive('/dashboard')}
                      $mini={isSideBarMini}
                    >
                      <Link to="/dashboard">
                        <FiPieChart />
                        <span>
                          <p>Dashboard</p>
                        </span>
                      </Link>
                    </Item>
                  )}
                  {hasPlayer && (
                    <Item $active={isActive('/player')} $mini={isSideBarMini}>
                      <Link to="/player">
                        <FiYoutube />
                        <span>
                          <p>Player</p>
                        </span>
                      </Link>
                    </Item>
                  )}
                  {hasMelhoriaDoBreak && (
                    <Item
                      $active={isActive('/melhoriadobreak')}
                      $mini={isSideBarMini}
                    >
                      <Link to="/melhoriadobreak">
                        <FiStar />
                        <span>
                          <p>Melhoria Break</p>
                        </span>
                      </Link>
                    </Item>
                  )}
                  {(hasOpec || hasRoteiroExclusao || hasORA) && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseOpec}
                      $active={
                        isActive('/materiais') ||
                        isActive('/roteiros') ||
                        isActive('/promos') ||
                        isActive('/exclusao') ||
                        isActive('/ora')
                      }
                      type="collapsed"
                    >
                      <button onClick={() => setCollapseOpec(!collapseOpec)}>
                        <FiInbox />
                        <span>
                          <p>Opec</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          {hasOpec && (
                            <>
                              <Item
                                $active={isActive('/materiais')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/materiais">
                                  <h5>MT</h5>
                                  <span>
                                    <p>Materiais</p>
                                  </span>
                                </Link>
                              </Item>
                              <Item
                                $active={isActive('/promos')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/promos">
                                  <h5>PM</h5>
                                  <span>
                                    <p>Promos</p>
                                  </span>
                                </Link>
                              </Item>
                            </>
                          )}
                          {(hasORA || hasOpec) && (
                            <Item
                              $active={isActive('/ora')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/ora">
                                <h5>OR</h5>
                                <span>
                                  <p>ORA</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasRoteiroExclusao && (
                            <>
                              <Item
                                $active={isActive('/roteiros')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/roteiros">
                                  <h5>RT</h5>
                                  <span>
                                    <p>Roteiros</p>
                                  </span>
                                </Link>
                              </Item>
                              <Item
                                $active={isActive('/exclusao')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/exclusao">
                                  <h5>LV</h5>
                                  <span>
                                    <p>Livres</p>
                                  </span>
                                </Link>
                              </Item>
                            </>
                          )}
                        </Menu>
                      </div>
                    </Item>
                  )}
                  {hasEleicoes && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseEleicoes}
                      $active={
                        isActive('/eleicoes/dashboard') ||
                        isActive('/eleicoes/painel') ||
                        isActive('/eleicoes/mapademidia') ||
                        isActive('/eleicoes/substituicao')
                      }
                      type="collapsed"
                    >
                      <button
                        onClick={() => setCollapseEleicoes(!collapseEleicoes)}
                      >
                        <BsCalendar2Check stroke="0" />
                        <span>
                          <p>Eleições</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          <Item
                            $active={isActive('/eleicoes/dashboard')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/eleicoes/dashboard">
                              <h5>DB</h5>
                              <span>
                                <p>Dashboard</p>
                              </span>
                            </Link>
                          </Item>
                          <Item
                            $active={isActive('/eleicoes/painel')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/eleicoes/painel">
                              <h5>PO</h5>
                              <span>
                                <p>Painel</p>
                              </span>
                            </Link>
                          </Item>
                          <Item
                            $active={isActive('/eleicoes/mapademidia')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/eleicoes/mapademidia">
                              <h5>MM</h5>
                              <span>
                                <p>Mapa de Mídia</p>
                              </span>
                            </Link>
                          </Item>
                          <Item
                            $active={isActive('/eleicoes/substituicao')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/eleicoes/substituicao">
                              <h5>SB</h5>
                              <span>
                                <p>Substituição</p>
                              </span>
                            </Link>
                          </Item>
                        </Menu>
                      </div>
                    </Item>
                  )}
                  {(hasChamada ||
                    hasPromo ||
                    hasClosedCaption ||
                    hasOptativosLocais) && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapsePromo}
                      $active={
                        isActive('/chamadas') ||
                        isActive('/spotradio') ||
                        isActive('/calendariopromo') ||
                        isActive('/closedcaption') ||
                        isActive('/roteiropromo') ||
                        isActive('/optativoslocais')
                      }
                      type="collapsed"
                    >
                      <button onClick={() => setCollapsePromo(!collapsePromo)}>
                        <FiVoicemail />
                        <span>
                          <p>Produção</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          {hasChamada && (
                            <Item
                              $active={isActive('/chamadas')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/chamadas">
                                <h5>CH</h5>
                                <span>
                                  <p>Chamadas</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasPromo && (
                            <>
                              <Item
                                $active={isActive('/spotradio')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/spotradio">
                                  <h5>SR</h5>
                                  <span>
                                    <p>Spot Rádios</p>
                                  </span>
                                </Link>
                              </Item>

                              <Item
                                $active={isActive('/roteiropromo')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/roteiropromo">
                                  <h5>RP</h5>
                                  <span>
                                    <p>Roteiros</p>
                                  </span>
                                </Link>
                              </Item>
                              <Item
                                $active={isActive('/anunciojornal')}
                                $mini={isSideBarMini}
                              >
                                <Link to="/anunciojornal">
                                  <h5>AJ</h5>
                                  <span>
                                    <p>Anuncio Jornais</p>
                                  </span>
                                </Link>
                              </Item>
                            </>
                          )}
                          {(hasProg || hasPromo) && (
                            <Item
                              $active={isActive('/calendariopromo')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/calendariopromo">
                                <h5>CL</h5>
                                <span>
                                  <p>Calendário</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasClosedCaption && (
                            <Item
                              $active={isActive('/closedcaption')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/closedcaption">
                                <h5>CC</h5>
                                <span>
                                  <p>Closed Captions</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasOptativosLocais && (
                            <Item
                              $active={isActive('/optativoslocais')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/optativoslocais">
                                <h5>PP</h5>
                                <span>
                                  <p>Optativos Locais</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                        </Menu>
                      </div>
                    </Item>
                  )}
                  {
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseSolicitacoes}
                      $active={
                        isActive('/solicitacaodigital') ||
                        isActive('/solicitacaopromo') ||
                        isActive('/solicitacaochamada') ||
                        isActive('/solicitacaodigital') ||
                        isActive('/sugestaopauta') ||
                        isActive('/sugestaopromo')
                      }
                      type="collapsed"
                    >
                      <button
                        onClick={() =>
                          setCollapseSolicitacoes(!collapseSolicitacoes)
                        }
                      >
                        <FiFileText />
                        <span>
                          <p>Solicitações</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          {hasSolicitacaoPromo && (
                            <Item
                              $active={isActive('/solicitacaopromo')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/solicitacaopromo">
                                <h5>SP</h5>
                                <span>
                                  <p>Sol. Promos</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasSolicitacaoChDigital && (
                            <Item
                              $active={isActive('/solicitacaochamada')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/solicitacaochamada">
                                <h5>SC</h5>
                                <span>
                                  <p>Sol. Chamadas</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasSolicitacaoChDigital && (
                            <Item
                              $active={isActive('/solicitacaodigital')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/solicitacaodigital">
                                <h5>SD</h5>
                                <span>
                                  <p>Sol. Digital</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          <Item
                            $active={isActive('/sugestaopauta')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/sugestaopauta">
                              <h5>SP</h5>
                              <span>
                                <p>Sugestão Pauta</p>
                              </span>
                            </Link>
                          </Item>
                          <Item
                            $active={isActive('/sugestaopromo')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/sugestaopromo">
                              <h5>SP</h5>
                              <span>
                                <p>Sugestão Promo</p>
                              </span>
                            </Link>
                          </Item>
                        </Menu>
                      </div>
                    </Item>
                  }
                  {hasArquivamento && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseCedoc}
                      $active={isActive('/arquivamento')}
                      type="collapsed"
                    >
                      <button onClick={() => setCollapseCedoc(!collapseCedoc)}>
                        <FiArchive />
                        <span>
                          <p>Cedoc</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          <Item
                            $active={isActive('/arquivamento')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/arquivamento">
                              <h5>AQ</h5>
                              <span>
                                <p>Arquivamento</p>
                              </span>
                            </Link>
                          </Item>
                        </Menu>
                      </div>
                    </Item>
                  )}
                  {hasIndicadorComercial && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseIndicadores}
                      $active={isActive('/indicadores/comercial')}
                      type="collapsed"
                    >
                      <button
                        onClick={() =>
                          setCollapseIndicadores(!collapseIndicadores)
                        }
                      >
                        <FiTrendingUp />
                        <span>
                          <p>Indicadores</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          <Item
                            $active={isActive('/indicadores/comercial')}
                            $mini={isSideBarMini}
                          >
                            <Link to="/indicadores/comercial">
                              <h5>IC</h5>
                              <span>
                                <p>Comercial</p>
                              </span>
                            </Link>
                          </Item>
                        </Menu>
                      </div>
                    </Item>
                  )}
                  {hasCriativos && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseCriativos}
                      $active={isActive('/criativos')}
                      type="collapsed"
                    >
                      <Link to="/criativos">
                        <FiCoffee />
                        <span>
                          <p>Criativos</p>
                        </span>
                      </Link>
                    </Item>
                  )}
                  {(hasUsuario || hasRelatorio || hasPrograma) && (
                    <Item
                      $mini={isSideBarMini}
                      $collapse={collapseAdmin}
                      $active={
                        isActive('/usuarios') ||
                        isActive('/relatorios') ||
                        isActive('/programas')
                      }
                      type="collapsed"
                    >
                      <button onClick={() => setCollapseAdmin(!collapseAdmin)}>
                        <FiKey />
                        <span>
                          <p>Admin</p>
                          <b />
                        </span>
                      </button>
                      <div>
                        <Menu>
                          {hasUsuario && (
                            <Item
                              $active={isActive('/usuarios')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/usuarios">
                                <h5>US</h5>
                                <span>
                                  <p>Usuários</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasRelatorio && (
                            <Item
                              $active={isActive('/relatorios')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/relatorios">
                                <h5>RL</h5>
                                <span>
                                  <p>Relatórios</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                          {hasPrograma && (
                            <Item
                              $active={isActive('/programas')}
                              $mini={isSideBarMini}
                            >
                              <Link to="/programas">
                                <h5>PG</h5>
                                <span>
                                  <p>Programas</p>
                                </span>
                              </Link>
                            </Item>
                          )}
                        </Menu>
                      </div>
                    </Item>
                  )}
                </Scroll>
              )}
            </Menu>
          </div>
        </SideBar>

        <Content $mini={isSideBarMini}>
          <Scroll height="calc(100vh - 87px)">{children}</Scroll>
        </Content>
      </Container>
    </Wrapper>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
